import { render } from "./SuppliesOverviewPage.vue?vue&type=template&id=041e305f&scoped=true"
import script from "./SuppliesOverviewPage.vue?vue&type=script&lang=js"
export * from "./SuppliesOverviewPage.vue?vue&type=script&lang=js"

import "@/css/GuestsPage.css?vue&type=style&index=0&lang=css&external"
import "@/css/AppLayout.css?vue&type=style&index=1&lang=css&external"
import "./SuppliesOverviewPage.vue?vue&type=style&index=2&id=041e305f&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-041e305f"]])

export default __exports__